// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"871f3ff9","667":"d6bacdbb","821":"dc85a8bd"}[chunkId] + ".chunk.js";
};